export class Cart {
	constructor() {
		//this.yaCounter = yaCounter52696993;
		//sbjs.init();
	}

	add2cart(id, count) {
		let _this = this
		$.ajax({
			url: "/ajax.php?mid=2",
			type: "POST",
			data: "action=add&id=" + id + "&count=" + count,
			dataType: "json",
			success: function(res) {
				//console.log(res.new_count);
				_this.updateHeader(res.new_count)
				//yaCounter8888326.reachGoal('add_to_cart');
				// if (confirm('Товар добавлен в корзину. Хотите оформить заказ?'))
				// {
				// 	window.location.replace('/cart/');
				// }
				$('#popup-cart').fadeIn();

				$('#popup-cart .goods-desc-name').text(res.name);
				$('#popup-cart .goods-desc-price-new').text(res.price);
				$('#popup-cart .goods-desc-price-old').text(res.oldprice);
				if (res.oldprice == 0)
					$('#popup-cart .goods-desc-price-old').hide();
				$('#popup-cart .goods-block-item-link-block-image img').attr('src', res.img);


				$('#popup-cart .popup-cart-count').text(res.new_count);
				$('#popup-cart .popup-cart-sum').text(res.new_sum);
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	remove(id) {
		let _this = this
		$.ajax({
			url: "/ajax.php?mid=2",
			type: "POST",
			data: "action=deleteRestoreCart&id=" + id + "&op=delete",
			dataType: "json",
			success: function(res) {
				//console.log(res.new_count);
				_this.updateHeader(res.new_count)
				_this.parseCartInfo(res)
				//window.location.reload();
				//yaCounter8888326.reachGoal('add_to_cart');
				if (!res.new_count) {
					$(".inner-page__title.inner-page__title--big").replaceWith(
						"<h1 class='inner-page__title'>В корзине нет товаров. <a href='/catalog/'>Добавить?</a></h1>"
					)
					$(".split").remove()
				}
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	updateCount(parent) {
		let el = $(parent)
		let count = el.val()
		let id
		if (el.closest(".popup-cart").length) {
			id = el
				.closest(".cart-item")
				.find("input.cart-item-id")
				.val()
			this.updateItemCount(id, count)
		} else if (el.closest(".cart-item").length) {
			id = el.closest(".cart-item").attr("data-id")
			this.updateCartCount(id, count)
		}
	}

	updateItemCount(id, count) {
		let _this = this
		$.ajax({
			url: "/ajax.php?mid=2",
			type: "POST",
			data: "action=update_item_count&id=" + id + "&count=" + count,
			dataType: "json",
			success: function(res) {
				//console.log(res.new_count);
				_this.updateHeader(res.new_count)
				//yaCounter8888326.reachGoal('add_to_cart');
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	updateCartCount(id, count) {
		let _this = this
		$.ajax({
			url: "/ajax.php?mid=2",
			type: "POST",
			data: "action=update_cart_count&id=" + id + "&count=" + count,
			dataType: "json",
			success: function(res) {
				//console.log(res.new_count);
				_this.updateHeader(res.new_count)
				_this.parseCartInfo(res)
				//yaCounter8888326.reachGoal('add_to_cart');
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	updateHeader(count) {
		console.log(count)
		let text = '';
		if (count == null) {
			count = 0
		}

		if (count > 0)
		{
			let end = '';
			if (count % 10 == 1 && count % 100 != 11)
				end = '';
			else if ((count % 10 > 1 && count % 10 < 5) && (count % 100 < 11 || count % 100 > 15))
				end = 'а';
			else
				end = 'ов';
			text = '(' + count + ' товар' + end + ')';
		} else {
			text = '(Пусто)';
		}

		$(".header-basket__text .header-basket__desc").text(text)
	}

	getDiscount() {
		let _this = this
		let card = $("#mod_cart_1_discount_card_number").val()
		if (!card) return

		$.ajax({
			url: "/ajax.php?mid=2",
			type: "POST",
			data: "action=getDiscount&card=" + card,
			dataType: "json",
			success: function(res) {
				console.log(res)
				if (res.status == "success") {
					$(".cart-form__discount-text")
						.text("Ваша скидка по карте: " + res.discount + "%")
						.attr("data-discount", res.discount)
				} else {
					$(".cart-form__discount-text")
						.text("Карта не найдена")
						.attr("data-discount", 0)
				}
				_this.calcTotalSum()
				$(".cart-form__discount-text").slideDown()
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	getCartCount() {
		let _this = this
		$.ajax({
			url: "/ajax.php?mid=2",
			type: "POST",
			data: "action=getCartCount",
			dataType: "json",
			success: function(res) {
				console.log(res.new_count)
				_this.updateHeader(res.new_count)
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	validAdress(adress) {
		$(".cart-form__submit").prop("disabled", true)
		let _this = this
		$.ajax({
			url: "/ajax.php?mid=2&action=validAdress",
			type: "POST",
			data: { adress: adress },
			dataType: "json",
			success: function(res) {
				$(".cart-form__submit").prop("disabled", false)
				let field = $("#str_adress")
				let qc_text = {
					10: "неизвестный дом",
					9: "неизвестный адрес",
					7: "похоже на иностранный адрес",
					6: "неизвестный нам адрес :-(",
					5: "еще можно указать квартиру",
					4: "укажите дом",
					3: "укажите улицу",
					2: "укажите город",
					1: "укажите регион",
					0: "адрес корректный!",
				}
				console.log(res)
				if (res.qc_complete === 0) {
					field[0].setCustomValidity("")
					field.val(res.result)
					field
						.parent()
						.find(".cart-form__data-comment")
						.text(qc_text[res.qc_complete])
				} else if (res.qc_complete == 5) {
					field[0].setCustomValidity("")
					field.val(res.result)
					field
						.parent()
						.find(".cart-form__data-comment")
						.text(qc_text[res.qc_complete])
				} else if (res.qc_complete == 10) {
					field[0].setCustomValidity("")
					field.val(res.result)
					field
						.parent()
						.find(".cart-form__data-comment")
						.text("")
				} else {
					field[0].setCustomValidity(qc_text[res.qc_complete])
					field
						.parent()
						.find(".cart-form__data-comment")
						.text(qc_text[res.qc_complete])
				}
			},
			fail: function(e) {
				$(".cart-form__submit").prop("disabled", false)
				console.log(e)
			},
		})
	}

	findOrg(inn, findOrg) {
		let _this = this
		$.ajax({
			url: "/ajax.php?mid=2&action=findOrg",
			type: "POST",
			data: { inn: inn, type_org: findOrg },
			dataType: "json",
			success: function(res) {
				console.log(res)

				if (res.suggestions != undefined) {
					if (res.suggestions.length > 0) {
						let org = res.suggestions[0].data

						if (org.name != undefined) {
							if ($("input[name='str_org']").val() == "") {
								if (
									org.name.short_with_opf != undefined &&
									org.name.short_with_opf.length > 0
								) {
									$("input[name='str_org']").val(org.name.short_with_opf)
								} else if (
									org.name.full_with_opf != undefined &&
									org.name.full_with_opf.length > 0
								) {
									$("input[name='str_org']").val(org.name.full_with_opf)
								}
							}
						}

						if (org.kpp != undefined) {
							if ($("input[name='str_kpp']").val() == "")
								$("input[name='str_kpp']").val(org.kpp)
						}

						if (org.address != undefined) {
							if ($("input[name='str_adress_j']").val() == "") {
								if (
									org.address.unrestricted_value != undefined &&
									org.address.unrestricted_value.length > 0
								) {
									$("input[name='str_adress_j']").val(
										org.address.unrestricted_value
									)
								} else if (
									org.address.value != undefined &&
									org.address.value.length > 0
								) {
									$("input[address='str_adress_j']").val(org.address.value)
								}
							}
						}
					}
				}
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	getCartInfo() {
		let _this = this
		$.ajax({
			url: "/ajax.php?mid=2",
			type: "POST",
			data: "action=getCartInfo",
			dataType: "json",
			success: function(res) {
				console.log(res)
				_this.updateHeader(res.count)
				_this.parseCartInfo(res)
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	checkBeforeSubmit() {
		let _this = this
		let noPay = false
		$.ajax({
			url: "/ajax.php?mid=2",
			type: "POST",
			async: false,
			data: "action=getCartInfo",
			dataType: "json",
			success: function(res) {
				console.log(res)
				_this.parseCartInfo(res)
				let noOrder = res.no_order
				if (noOrder) {
					$([document.documentElement, document.body]).animate(
						{
							scrollTop: $("h1").offset().top,
						},
						200
					)
					swal(
						"Внимание!",
						"Один или несколько товаров закончились, пожалуйста, удалите их из корзины, чтобы оформить заказ."
					)
				}
			},
			fail: function(e) {
				console.log(e)
			},
		})

		return !noPay
	}

	makeOrder(parent) {
		let _this = this
		let el = $(parent)
		$.ajax({
			url: "/ajax.php?mid=2",
			type: "POST",
			data: el.serialize() + "&action=makeOrder",
			dataType: "json",
			success: function(res) {
				if (res.success) 
				{
					$('.cart-block-info-design-success-text span').text(res.orderId);
					$('.cart-block-info-design-success').addClass('active');
				}
				else
				{
					alert('Ошибка: ' + res.error);
				}
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	parseCartInfo(res) {
		$('.cart-block-info-goods').replaceWith(res['goods']);
		$('.cart-block-info-design').replaceWith(res['info']);

		document.querySelectorAll('.count .minus').forEach(item => {
			item.addEventListener('click', function () {
				--item.parentElement.querySelector('input').value;
				if (item.parentElement.querySelector('input').value < 2) 
				{
					item.parentElement.querySelector('input').value = 1;
					item.classList.add('min');
				}
				$(item.parentElement.querySelector('input')).trigger('change');
			});
		});

		document.querySelectorAll('.count .plus').forEach(item => {
			item.addEventListener('click', function () {
				++item.parentElement.querySelector('input').value;
				if (item.parentElement.querySelector('input').value > 1) 
				{
					item.parentElement.querySelector('.minus').classList.remove('min');
				}
				$(item.parentElement.querySelector('input')).trigger('change');
			});
		});
	}

	calcTotalSum() {
		let sum = $("#cart_sum").text()
		let deliveryId = $(".cart-form__radio-item input:checked").val()
		let discount = $(".cart-form__discount-text").attr("data-discount")
		let deliverySum = 0

		if (deliveryId)
			deliverySum = parseInt(
				$(".cart-form__radio-item input:checked")
					.closest(".cart-form__radio-item")
					.find(".cart-form__radio-title b")
					.text()
			)

		$("#cart_delivery_sum").text(deliverySum)
		$("#cart_total_sum").text(parseInt(sum) + parseInt(deliverySum))

		$("#cart_total_sum2").text(
			((parseInt(sum) + parseInt(deliverySum)) * (100 - discount)) / 100
		)
	}
}
